export const classes = {
  itemIcon: 'cursor-pointer',
  titleWrapper: 'place-between',
  title:
    'text-grey-8 dark:text-mauve-1 font-medium text-sm mr-3 hover:underline cursor-pointer outline-none',
  tag: 'ml-4',
  description: 'text-sm text-grey-6 dark:text-mauve-3',
  auroraRow:
    'mx-0 mb-[11px] w-full items-center rounded-2xl border border-solid border-black/10 bg-white/[0.82] px-4 py-3 shadow-aurora-card transition-[box-shadow,border-color] hover:border-brand-accent/55 hover:shadow-row-hover dark:border-white/10 dark:bg-[#332e43]/[0.84]',
  auroraContent: 'flex w-full items-center gap-3',
  auroraText: 'flex flex-col grow min-w-0',
  auroraTitle:
    'text-left text-[13.5px] font-semibold text-taupe-3 truncate hover:underline cursor-pointer outline-none dark:text-mauve-1',
  auroraSub: 'text-[11.5px] text-taupe-1 mt-[3px] dark:text-mauve-3',
  auroraTag: 'ml-2 shrink-0',
  auroraPill:
    'rounded-full border-0 bg-black/[0.05] px-[11px] py-[4px] text-[11px] font-semibold tracking-[0.03em] text-taupe-2 dark:bg-white/[0.07] dark:text-mauve-2',
};
